import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Observable, throwError } from 'rxjs';
import { ErrorDto } from '../models/error-dto';
import { ErrorResponseDto } from '../models/error-response-dto';
import { FieldErrorDto } from '../models/field-error-dto';

import { MessageService } from 'primeng/api';


import { CommonMessageTransferService } from '../services/common-message-transfer.service';
import { LoaderService } from './../components/loader/loader.service';

export type HandleError = <T>(
  identifier?: string,
  result?: T
) => (error: HttpErrorResponse) => Observable<T>;
@Injectable({
  providedIn: 'root'
})
export class HttpErrorHandler {
  constructor(
    private router: Router,
    private messageService: MessageService,
    private loaderService: LoaderService,
    private commonMsgTrasferService: CommonMessageTransferService
  ) { }
  createHandleError = () => <T>(identifier = 'unknown', result = {} as T) =>
    this.handleError(identifier, result);


  handleError<T>(identifier = 'unknown', result = {} as T) {
    return (error: HttpErrorResponse): Observable<T> => {
      this.messageService.clear();
      this.loaderService.hide();
      if (error.status === 0) {
        this.messageService.add({
          severity: 'error',
          summary: 'Server Unreachable.',
          detail: 'Sorry, seems like server is unreachable.'
        });
        return throwError(result);
      }

      if (error.status === 500) {
        this.parseFieldErrors(error, identifier, 500);
        return throwError(error.error);
      }

      if (error.status === 401 || error.status === 403) {
        if (error?.error?.errors?.general && error.error.errors.general.length > 0) {
          const errorMessage = error.error.errors.general[0].message || 'Invalid credentials. Please try again.';
          this.messageService.add({ key: 'tst', severity: 'error', summary: 'Error Message', detail: errorMessage });
        } else if (error?.error) {
          this.messageService.add({ key: 'tst', severity: 'error', summary: 'Error Message', detail: 'Invalid credentials. Please try again.' });
        }
        this.router.navigate(['/auth/login']);
        return throwError(error);
      }

      if (error.error.errors !== undefined && error.error.errors !== null) {
        if (error.status === 400) {
          this.parseFieldErrors(error, identifier, 400);
          return throwError(error.error);
        }
      }

      return throwError(result);
    };
  }

  manageGeneralMsg(generalDto: ErrorDto, code: number) {
    let errorHeader = 'Error';
    if (code === 500) {
      errorHeader = 'Server Error';
    }
    if (code === 400 && generalDto.messageCode === 'error.entity.notFound') {
      // eslint-disable-next-line no-empty
    } else {
      this.messageService.add({
        severity: 'error',
        summary: errorHeader,
        detail: generalDto.message
      });
    }

    this.commonMsgTrasferService.throwGeneralError(generalDto);
  }

  parseFieldErrors(error: HttpErrorResponse, identifier: string, code: number) {
    const fieldResponse: FieldErrorDto[] = [];
    const keys = Object.keys(error.error.errors);
    let isGeneralError = false;

    keys.forEach(key => {
      if (isGeneralError) {
        return;
      }
      const fieldErrors: ErrorDto[] = error.error.errors[key];
      if (key === 'general') {
        isGeneralError = true;
        fieldErrors[0].identifier = identifier;
        this.manageGeneralMsg(fieldErrors[0], code);
        return;
      }
      const dto: FieldErrorDto = new FieldErrorDto();
      dto.fieldName = key;
      dto.fieldsErrors = fieldErrors;
      fieldResponse.push(dto);

      fieldErrors.forEach(fieldError => {
        this.messageService.add({
          severity: 'error',
          summary: 'Field Error',
          detail: `${this.formatFieldName(key)}: ${fieldError.message}`
        });
      });
    });

    if (isGeneralError) {
      return;
    }

    const errorResponse: ErrorResponseDto = new ErrorResponseDto();
    errorResponse.fieldsErrors = fieldResponse;
    errorResponse.identifier = identifier;
    this.commonMsgTrasferService.throwFieldsError(errorResponse);
  }

  private formatFieldName(fieldName: string): string {
    return fieldName
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
